import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import FadeIn from 'react-fade-in/lib/FadeIn';
import './styles.scss';
import { Card, Dropdown, DropdownButton } from 'react-bootstrap';
import ImgComponent from '../../../../HOCs/ImageHocs';
import { IMAGE_MODE } from '../../../../constants/imageMode';
import { getContentImageByMode } from '../../../../utils/imageUtils';
import Imgcomponent from '../../../../HOCs/ImageHocs';
import { IMAGE_CROP_MODES } from '../../../shared/constants';
import { areIntervalsOverlapping, isToday } from 'date-fns';

function EPGChannelList({
  selectedProgramItem,
  contentNoImageProps,
  channelList = [],
  activeKey,
  scrollRef,
  handleOnScroll,
  imageMode = IMAGE_MODE.THUMB,
  handleOnSelectedProgramChannel,
  onClickBroadcast,
  selectedDay,
  broadcast, 
  enableEpgDropdown
}) {

  const onClickChannel = (c) => {
    handleOnSelectedProgramChannel(c.epgId)
  }

  /*React.useEffect(() => {
    if (isToday(selectedDay) && channel) {

      const channelResult = channelList.find((e) => (e.epgId === channel))

      const programItemResult = channelResult?.epg.find((programItem) => {
        return areIntervalsOverlapping(
          { start: new Date(), end: new Date() },
          { start: Date.parse(programItem.startTime), end: Date.parse(programItem.endTime) }),
          { inclusive: true }
      })

      if (programItemResult) {
        const channelR = channel;
        handleOnSelectedProgramItem(programItemResult, channelR)
        setChanel(false)
      }
    }
  }, [selectedDay])*/

  return (<div className='epgGridList_container_channel' onScroll={handleOnScroll} ref={scrollRef}>
    <Accordion className='epgGridList_row_channel' activeKey={activeKey}>
      {channelList?.length > 0 &&  channelList.map((e, index) =>
        <Card className='epgGridList_row_channel_card' key={'epgGridList_row_channel_card-'+e.epgId+'-'+index}>
          <Card.Header className='epgGridList_row_channel_header'>
            <a className='epgGridList_row_channel_header_container' onClick={() => onClickChannel(e)}>
              <div className="epgGridList_row_channel_container_img">
                <ImgComponent
                  className="epgGridList_row_channel_img"
                  src={getContentImageByMode(e.images, IMAGE_MODE.THUMB)?.url}
                  crop={IMAGE_CROP_MODES.resizeScaleAndCrop}
                  size={IMAGE_MODE.THUMB}
                  setimagebool={(e) => console.log(e)}
                  alt={e.title}
                />
              </div>
              {/*<div className="epgGridList_row_channel_container_title">
                <div className='epgGridList_row_channel_title'>{e.title}</div>
               </div>*/}
            </a>
          </Card.Header>
          { enableEpgDropdown && <Accordion.Collapse className="epgGridList_row_channel_collapse" eventKey={e.epgId}>
            <Card.Body className="epgGridList_row_channel_body">
              {!!selectedProgramItem && e.epgId === activeKey && (() => (<div className='epgGridList_row_channel_body_img_container'>
                <Imgcomponent
                  className="epgGridList_row_channel_body_img"
                  src={getContentImageByMode(e.images, IMAGE_MODE.THUMB)?.url}
                  crop={IMAGE_CROP_MODES.resizeScaleAndCrop}
                  size={imageMode}
                  setimagebool={(e) => console.log(e)}
                  alt={e.title+' body'}
                />
              </div>))()
              }
            </Card.Body>
          </Accordion.Collapse>}
        </Card>
      )}
    </Accordion>
  </div>);
};

export default React.memo(EPGChannelList);